import { StyleProp, View, ViewStyle } from 'react-native';

import { Skeleton, SkeletonTextBlock, createMqStyles, tokens } from '@fhs/ui';
import { useIsDesktopBp } from '@fhs-legacy/frontend/src/hooks/breakpoints';

import { useChallengeCardWidth } from '../challenge-card/challenge-card';

export function ChallengeCardSkeleton({ style }: { style?: StyleProp<ViewStyle> }) {
  const isDesktop = useIsDesktopBp();
  const itemWidth = useChallengeCardWidth();
  const styles = useMqStyles();

  return (
    <View style={[{ width: itemWidth }, styles.card, style]}>
      <View style={styles.imageContainer}>
        <Skeleton style={styles.imageSkeleton} />
      </View>
      <View style={styles.content}>
        {isDesktop && <SkeletonTextBlock lines={1} lineStyle={styles.title} />}
        <SkeletonTextBlock lines={2} />
        <Skeleton style={styles.skeletonButton} />
      </View>
    </View>
  );
}

const useMqStyles = createMqStyles({
  card: {
    $base: {
      borderColor: tokens.colors.$blackOpacity10,
      borderWidth: 1,
      borderRadius: 8,
      overflow: 'hidden',
    },
    $gteDesktop: {
      flexDirection: 'row',
      height: 253,
    },
  },
  imageContainer: {
    $base: {
      aspectRatio: 2,
      borderRadius: 0,
    },
    $ltDesktop: {
      width: '100%',
    },
    $gteDesktop: {
      height: '100%',
    },
  },
  imageSkeleton: {
    $base: {
      flex: 1,
      borderRadius: 0,
    },
  },
  content: {
    $gteDesktop: {
      flex: 1,
      padding: 32,
      borderLeftWidth: 1,
      borderColor: tokens.colors.$blackOpacity10,
      justifyContent: 'center',
    },
    $ltDesktop: {
      padding: 12,
      borderTopWidth: 1,
      borderColor: tokens.colors.$blackOpacity10,
    },
  },
  title: {
    $gteDesktop: {
      height: 20,
      marginBottom: 8,
    },
  },
  skeletonButton: {
    $base: {
      height: 31,
      marginTop: 16,
    },
  },
});
